import React, { useEffect, useRef, useState, useContext } from "react";
import { CaretDownFill, CaretUpFill } from "../Icons/CaretIcon";
import { message } from "antd";
import MagicWand from "../Icons/MagicWand";
import { useHistory } from "react-router-dom";
import FiltersContext from "../../contexts/Filters";
import * as Md from "../../md/full";
import { newPositiveAttributeFilter } from "@gooddata/sdk-model";
import { useAppContext } from "../../contexts/AppContext";
const ExtendedTable = ({ columns, data, onSort, stickyColumn, columnGroups }) => {
    const contentRef = useRef();
    const scrollRef = useRef();
    const [contentWidth, setContentWidth] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const history = useHistory();
    const { clearFilters, updateFilter } = useContext(FiltersContext);
    const { setMatchVehicle } = useAppContext();
    const rowsPerPage = 100;
    const totalPages = Math.ceil(data.length / rowsPerPage);

    const syncScroll = (src, target) => {
        target.current.scrollLeft = src.current.scrollLeft;
    };

    const handleContentScroll = () => syncScroll(contentRef, scrollRef);
    const handleScrollScroll = () => syncScroll(scrollRef, contentRef);
    useEffect(() => {
        const contentElement = contentRef.current;
        const scrollElement = scrollRef.current;

        if (contentElement && scrollElement) {
            //@ts-ignore
            setContentWidth(contentElement?.scrollWidth);
            //@ts-ignore
            contentElement?.addEventListener("scroll", handleContentScroll);
            //@ts-ignore
            scrollElement?.addEventListener("scroll", handleScrollScroll);

            return () => {
                //@ts-ignore
                contentElement?.removeEventListener("scroll", handleContentScroll);
                //@ts-ignore
                scrollElement?.removeEventListener("scroll", handleScrollScroll);
            };
        }
    }, [handleContentScroll, handleScrollScroll, contentRef, scrollRef]);

    const getCurrentPageData = () => {
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return data.slice(startIndex, endIndex);
    };

    const handleSort = (col, direction) => {
        setSortConfig({ key: col.key, direction });
        onSort(col, direction);
    };

    const handleVersionMatch = (record) => {
        if (record["List_Price"]) {
            // Set filters based on selected vehicle
            clearFilters();
            updateFilter("filterMake", newPositiveAttributeFilter(Md.CorrMake, [record.Make]));
            updateFilter("filterModel", newPositiveAttributeFilter(Md.CorrModel, [record.Model]));
            updateFilter("filterTrim", newPositiveAttributeFilter(Md.TrimName, [record.Trim]));
            updateFilter("filterFuel", newPositiveAttributeFilter(Md.Fuel, [record.Energy]));
            // updateFilter("filterGearPlus", newPositiveAttributeFilter(Md.GearsPlus, [record.Gear]));

            // Store selected vehicle data for automatic selection in car selector
            setMatchVehicle(record.Vehicle);

            // Navigate to car selector
            history.push("/vehicles");
        } else {
            message.warning("Please choose a vehicle with a list price.");
        }
    };

    return (
        <div className="flex flex-col gap-4">
            <div ref={scrollRef} className="overflow-x-scroll h-5">
                <div style={{ width: `${contentWidth}px` }} />
            </div>
            <div ref={contentRef} className="max-h-[500px] overflow-x-scroll rounded-lg scrollbar-hide shadow-md">
                <table className="table-fixed w-max border-collapse">
                    <colgroup>
                        {columns.map((col) => (
                            <col
                                key={col.key}
                                style={{
                                    minWidth: col.key === "Vehicle" ? "400px" : col.minWidth || "120px",
                                    maxWidth: col.key === "Vehicle" ? "550px" : col.maxWidth || "200px",
                                    width: col.key === "Vehicle" ? "400px" : col.width || "150px",
                                }}
                            />
                        ))}
                    </colgroup>
                    <thead className="sticky top-0 z-10 bg-white shadow-sm">
                        {columnGroups && (
                            <tr className="border-b">
                                {columnGroups.map((group, index) => (
                                    <th key={index} colSpan={group.span} className={group.className || "px-4 py-3 ont-semibold"}>
                                        {group.title}
                                    </th>
                                ))}
                            </tr>
                        )}
                        <tr className="border-b h-8">
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    className={`px-3 py-1 text-xs font-medium text-gray-500 transition-colors hover:bg-gray-100 cursor-pointer
                                    ${col.key === stickyColumn ? "sticky left-0 bg-white shadow-sm z-10" : ""}
                                    whitespace-nowrap overflow-hidden text-ellipsis`}
                                    onClick={() => onSort && handleSort(col, sortConfig.key === col.key && sortConfig.direction === "asc" ? "desc" : "asc")}
                                >
                                    <span className="flex items-center justify-between">
                                        <div className="flex-1">{col.title}</div>
                                        {onSort && (
                                            <div className="flex flex-col ml-2 opacity-70 hover:opacity-100">
                                                <span>
                                                    <CaretUpFill
                                                        width={12}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleSort(col, "desc");
                                                        }}
                                                        className={`fill-current cursor-pointer text-gray-300 hover:text-indigo-500 ${sortConfig.key === col.key && sortConfig.direction === "desc" ? "text-indigo-500" : ""}`}
                                                    />
                                                </span>
                                                <span>
                                                    <CaretDownFill
                                                        width={12}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleSort(col, "asc");
                                                        }}
                                                        className={`fill-current cursor-pointer text-gray-300 hover:text-indigo-500 ${sortConfig.key === col.key && sortConfig.direction === "asc" ? "text-indigo-500" : ""}`}
                                                    />
                                                </span>
                                            </div>
                                        )}
                                    </span>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {getCurrentPageData().map((row, rowIndex) => (
                            <tr key={rowIndex} className="border-b h-7 hover:bg-gray-50">
                                {columns.map((col) => (
                                    <td
                                        key={col.key}
                                        className={`px-3 py-1 bg-white
                                        ${col.key === stickyColumn ? "sticky left-0 text-left shadow-sm" : "text-center"} 
                                        ${col.key === "Vehicle" ? "text-left" : ""}
                                        text-gray-600 text-[11px]
                                        whitespace-nowrap overflow-hidden text-ellipsis`}
                                    >
                                        {col.key === "Vehicle" ? (
                                            <div className="flex items-center justify-between">
                                                <span className="text-ellipsis overflow-hidden">{row[col.key]}</span>
                                                <button onClick={() => handleVersionMatch(row)} className="hover:opacity-50">
                                                    <MagicWand className="w-4 h-4 text-indigo-900" />
                                                </button>
                                            </div>
                                        ) : (
                                            row[col.key]
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 rounded-b-lg shadow-sm">
                <div className="flex items-center gap-3">
                    <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="p-2 rounded-md text-gray-500 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m15 18-6-6 6-6" />
                        </svg>
                    </button>

                    <div className="flex items-center gap-1">
                        <span className="text-sm font-medium text-gray-700">{currentPage}</span>
                        <span className="text-gray-500 text-sm">/</span>
                        <span className="text-sm text-gray-500">{totalPages}</span>
                    </div>

                    <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} className="p-2 rounded-md text-gray-500 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m9 18 6-6-6-6" />
                        </svg>
                    </button>
                </div>

                <div>
                    <p className="text-xs text-gray-500">
                        Showing <span className="font-medium">{(currentPage - 1) * rowsPerPage + 1}</span> to <span className="font-medium">{Math.min(currentPage * rowsPerPage, data.length)}</span> of <span className="font-medium">{data.length}</span> results
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ExtendedTable;
